import React from 'react';
import * as css from './EmailTabImage.css';
import {useSelector} from 'react-redux';
import {defaultImage} from '../../../../assets/symbols/images/defaultImage';
import {givechakImage} from '../../../../assets/symbols/images/givechakImage';
import ExternalImagePopup from '../../../imagePopup/externalImagePopup/ExternalImagePopup';
import {TState} from '../../../../redux/store.type';

interface EmailTabImageProps {
    image: {path: string, imageId: string, creditName?: string, alt?: string, license?: string};
    saveImage: (image: any) => void;
}

function EmailTabImage({image, saveImage}: EmailTabImageProps) {
    const {type} = useSelector((s: TState) => s.event);
    const widthWindowWidth = useSelector((s: TState) => s.ui.windowWidth);
    const imageHeight = Math.min(Math.floor((widthWindowWidth-20)/3.94), 160);
    const defaultFallbackImage = type === 'givechak' ? givechakImage : defaultImage;

    const imageEditorProps = {
        size: {width: Math.min(630, widthWindowWidth-20), height: imageHeight},
        image: image?.path || (type=== 'givechak' ? givechakImage : defaultImage),
        imageId: image?.imageId,
        setImage: (newImage) => saveImage(newImage),
        type: 'image/png'
    };
    
    const creditProps = {
        creditName: image?.creditName,
        alt: image?.alt,
        license: image?.license,
    };

    return (
        <css.wrapImage color={undefined} height={`${imageHeight}px`} data-cy={'emailImage'}>
            {!image && <css.image className={type} image={defaultFallbackImage}/>}
            <ExternalImagePopup imageProps={imageEditorProps} creditProps={creditProps} absoluteImage={!image}/>
            <css.uploadIcon/>
        </css.wrapImage>
    );
}

export default EmailTabImage;
